module.exports = __webpack_public_path__ + "img/email.34312a45.svg";